import { render } from "./RequestClaimBuilder.vue?vue&type=template&id=183540fb&scoped=true&lang=pug"
import script from "./RequestClaimBuilder.vue?vue&type=script&lang=js"
export * from "./RequestClaimBuilder.vue?vue&type=script&lang=js"

import "./RequestClaimBuilder.vue?vue&type=style&index=0&id=183540fb&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183540fb"]])

export default __exports__